export const findFatalEntityEditValidationErrors = edits => {
    if (edits && edits.name && edits.name.includes('"')) return 'POI name cannot contain double quote character (")';

    return null;
};

export const sanitizeTagArrays = edits => {
    if (!edits) return edits;
    const sanitized = { ...edits };
    if (Array.isArray(sanitized.tags)) {
        sanitized.tags = sanitized.tags
            .filter(t => typeof t === 'string')
            .map(t => t.trim())
            .filter(Boolean);
    }
    if (Array.isArray(sanitized.displayTags)) {
        sanitized.displayTags = sanitized.displayTags
            .filter(t => typeof t === 'string')
            .map(t => t.trim())
            .filter(Boolean);
    }
    return sanitized;
};

export const isValidUrl = value => {
    if (!value) return true; // empty allowed
    try {
        const u = new URL(value);
        return u.protocol === 'https:';
    } catch {
        return false;
    }
};

export const URL_FIELD_LABELS = {
    url: 'Information URL',
    parkingUrl: 'Reserve Parking URL',
    mobileOrderingUrl: 'Mobile Ordering URL',
};

const urlErrorMessage = label => `${label} is invalid — must start with https://`;

// Returns map of fieldName -> error message for any invalid URL fields on the poi.
// Category-gated: parkingUrl only validated when category includes 'parking';
// mobileOrderingUrl only validated when category includes 'eat'.
export const findInvalidUrlErrors = poi => {
    if (!poi) return {};
    const errors = {};
    const category = (poi.category || '').toLowerCase();

    if (!isValidUrl(poi.url)) {
        errors.url = urlErrorMessage(URL_FIELD_LABELS.url);
    }
    if (category.includes('parking') && !isValidUrl(poi.parkingUrl)) {
        errors.parkingUrl = urlErrorMessage(URL_FIELD_LABELS.parkingUrl);
    }
    if (category.includes('eat') && !isValidUrl(poi.mobileOrderingUrl)) {
        errors.mobileOrderingUrl = urlErrorMessage(URL_FIELD_LABELS.mobileOrderingUrl);
    }

    return errors;
};

// Convenience: returns a multi-line string of all URL error messages, or null if none.
export const formatUrlErrorBanner = poi => {
    const errors = findInvalidUrlErrors(poi);
    const messages = Object.values(errors);
    if (messages.length === 0) return null;
    return messages.join('\n');
};

export const isValidPhone = value => {
    if (!value) return true; // empty allowed
    return /^([0-9+\-() ,]|EXT{1}|ext{1})+$/.test(value);
};

const phoneErrorMessage = 'Phone number is invalid — must contain only digits, +, -, (, ), commas, or spaces';

// Returns error message if phone is invalid, else null.
// Empty/null/undefined is valid (optional field).
export const findInvalidPhoneError = value => {
    if (!value) return null;
    if (!isValidPhone(value)) return phoneErrorMessage;
    return null;
};

export const PHONE_EXTENSION_MAX_LENGTH = 10;

// Returns error message if phoneExt is invalid (non-digits or >10 chars), else null.
// Empty/null/whitespace is valid (optional field).
export const findInvalidPhoneExtensionError = value => {
    if (value === null || value === undefined) return null;
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (trimmed === '') return null;
    if (!/^\d+$/.test(trimmed)) return 'Phone extension must contain digits only';
    if (trimmed.length > PHONE_EXTENSION_MAX_LENGTH)
        return `Phone extension must be ${PHONE_EXTENSION_MAX_LENGTH} digits or fewer`;
    return null;
};
